export default function parseDateFromISO(date: string): Date {
  const [year, month, day] = date.split('T')[0].split('-').map(Number);
  return new Date(year, month - 1, day);
}
